import { 
    Button, 
    FormControl, 
    FormLabel,
    Box,
    Select,
    HStack,
    VStack,
    Input,
    Checkbox,
    SimpleGrid,
    FormErrorMessage
} from "@chakra-ui/react";
import DrawerForm from "@shared/components/drawerForm";
import useCompanyProcessForm from "./useCompanyProcessForm";
import type { CompanyProcessFormProps } from "./types"

const CompanyProcessForm = ({
    isOpen, 
    companyProcess,
    companies,
    onClose, 
    onCreateCompanyProcess,
    onUpdateCompanyProcess
}: CompanyProcessFormProps) => {
    const {
        values,
        errors,
        touched, 
        handleReset, 
        handleSubmit,
        handleChange
    } = useCompanyProcessForm({
        companyProcess,
        isOpen ,
        onClose,
        onCreateCompanyProcess,
        onUpdateCompanyProcess
    })
    
    return(
        <DrawerForm 
            isOpen={isOpen} 
            onClose={onClose} 
            size="sm" 
            closeOnOverlayClick={false} 
            title={companyProcess ? 'Editar proceso de sociedad' : 'Agregar proceso de sociedad'}
        >
            <form onSubmit={handleSubmit} onReset={handleReset}>
                <Box as="fieldset">
                    <VStack spacing={4} mt={2}>
                        <FormControl isInvalid={errors.empresaId !== undefined && touched.empresaId}>
                            <FormLabel fontSize="sm" mb={0}>Sociedad</FormLabel>
                            <Select placeholder="Elegir empresa" value={values.empresaId} name="empresaId" onChange={handleChange} disabled={!!companyProcess}>
                                {companies?.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                            </Select>
                            <FormErrorMessage>{errors.empresaId}</FormErrorMessage>
                        </FormControl>
                        <FormControl isInvalid={errors.nombre !== undefined && touched.nombre}>
                            <FormLabel fontSize="sm" mb={0}>Nombre del proceso</FormLabel>
                            <Input placeholder="Nombre del proceso" value={values.nombre} name="nombre" onChange={handleChange}/>
                            <FormErrorMessage>{errors.nombre}</FormErrorMessage>
                        </FormControl>
                        <HStack w="100%" alignItems="start">
                            <FormControl isInvalid={errors.horaInicio !== undefined && touched.horaInicio}>
                                <FormLabel fontSize="sm" mb={0}>Hora de inicio</FormLabel>
                                <Input value={values.horaInicio} type="time" name="horaInicio" onChange={handleChange}/>
                                <FormErrorMessage>{errors.horaInicio}</FormErrorMessage>
                            </FormControl>
                            <FormControl isInvalid={errors.horaFin !== undefined && touched.horaFin}>
                                <FormLabel fontSize="sm" mb={0}>Hora final</FormLabel>
                                <Input value={values.horaFin} type="time" name="horaFin" onChange={handleChange}/>
                                <FormErrorMessage>{errors.horaFin}</FormErrorMessage>
                            </FormControl>
                        </HStack>
                        <SimpleGrid w="100%" columns={4}  rowGap={1} columnGap={1}>
                            <Checkbox name="lunes" isChecked={values.lunes} onChange={handleChange}>Lunes</Checkbox>
                            <Checkbox name="martes" isChecked={values.martes} onChange={handleChange}>Martes</Checkbox>
                            <Checkbox name="miercoles" isChecked={values.miercoles} onChange={handleChange}>Miercoles</Checkbox>
                            <Checkbox name="jueves" isChecked={values.jueves} onChange={handleChange}>Jueves</Checkbox>
                            <Checkbox name="viernes" isChecked={values.viernes} onChange={handleChange}>Viernes</Checkbox>
                            <Checkbox name="sabado" isChecked={values.sabado} onChange={handleChange}>Sabado</Checkbox>
                            <Checkbox name="domingo" isChecked={values.domingo} onChange={handleChange}>Domingo</Checkbox>
                        </SimpleGrid>
                        
                    </VStack>
                </Box>
                <HStack w="100%" bg="white" bottom={0} position="sticky" mt={8} spacing={2} justifyContent="end">
                    <Button type="reset" onClick={onClose}>Cancelar</Button>
                    <Button type="submit" colorScheme="blue">Guardar</Button>           
                </HStack>     
            </form>
        </DrawerForm>
    )
}

export default CompanyProcessForm